/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemSpecialityGroupSaveModel } from '../../models/system-speciality-group-save-model';
import { SystemSpecialityGroupViewModel } from '../../models/system-speciality-group-view-model';

export interface ApiAdminSystemSpecialityGroupsIdPut$Params {
  id: string;
      body?: SystemSpecialityGroupSaveModel
}

export function apiAdminSystemSpecialityGroupsIdPut(http: HttpClient, rootUrl: string, params: ApiAdminSystemSpecialityGroupsIdPut$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<SystemSpecialityGroupViewModel>> {
  const rb = new RequestBuilder(rootUrl, apiAdminSystemSpecialityGroupsIdPut.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<SystemSpecialityGroupViewModel>;
    })
  );
}

apiAdminSystemSpecialityGroupsIdPut.PATH = '/api/Admin/system-speciality-groups/{id}';
